import { NavigationItem } from '../types/navigation';

export interface PermissionNavigationItem extends NavigationItem {
  permission?: string;
  children?: PermissionNavigationItem[];
}

export const navigationConfig: PermissionNavigationItem[] = [
  {
    label: 'Startseite',
    path: '/',
    icon: 'LayoutDashboard',
    permission: 'dashboard.view',
  },
  {
    label: 'Personal',
    path: '/personal',
    icon: 'Users',
    permission: 'personnel.read',
    children: [
      { path: '/personal/mitarbeiter', label: 'Mitarbeiter', icon: 'User', permission: 'personnel.read' },
      { path: '/personal/akten', label: 'Mitarbeiterakten', icon: 'Folder', permission: 'personnel.read' },
      { path: '/personal/dienstplan', label: 'Dienstplan', icon: 'Calendar', permission: 'schedule.read' },
      { path: '/personal/abwesenheiten', label: 'Abwesenheiten', icon: 'UserMinus', permission: 'absences.read' },
      { path: '/personal/qualifikationen', label: 'Qualifikationen', icon: 'UserCheck', permission: 'qualifications.read' },
      { path: '/personal/fortbildungen', label: 'Fortbildungen', icon: 'BookOpen', permission: 'trainings.read' },
      { path: '/personal/organigramm', label: 'Organigramm', icon: 'GitBranch', permission: 'personnel.read' },
      { path: '/personal/telefonverzeichnis', label: 'Telefonverzeichnis', icon: 'Phone', permission: 'personnel.read' },
    ],
  },
  {
    label: 'Patienten',
    path: '/patienten',
    icon: 'Bed',
    permission: 'patients.read',
    children: [
      { path: '/patienten/betten', label: 'Bettenbelegung', icon: 'Bed', permission: 'beds.read' },
      { path: '/patienten/uebersicht', label: 'Patientenübersicht', icon: 'List', permission: 'patients.read' },
      { path: '/patienten/aufnahme', label: 'Aufnahme', icon: 'UserPlus', permission: 'admissions.create' },
      { path: '/patienten/verlegung', label: 'Verlegung', icon: 'ArrowRight', permission: 'transfers.create' },
      { path: '/patienten/entlassung', label: 'Entlassung', icon: 'UserMinus', permission: 'discharges.create' },
      { path: '/patienten/visite', label: 'Visite', icon: 'Stethoscope', permission: 'patients.read' },
      { path: '/patienten/pflege', label: 'Pflege-Dokumentation', icon: 'FileText', permission: 'nursing.read' },
      { path: '/patienten/uebergaben', label: 'Übergaben', icon: 'RefreshCw', permission: 'handovers.read' },
    ],
  },
  {
    label: 'Medizin',
    path: '/medizin',
    icon: 'Stethoscope',
    permission: 'medical.read',
    children: [
      { path: '/medizin/diagnosen', label: 'Diagnosen', icon: 'FileText', permission: 'diagnoses.read' },
      { path: '/medizin/befunde', label: 'Befunde', icon: 'Search', permission: 'findings.read' },
      { path: '/medizin/medikation', label: 'Medikation', icon: 'Pill', permission: 'medication.read' },
      { path: '/medizin/vitalwerte', label: 'Vitalwerte', icon: 'Activity', permission: 'vitals.read' },
      { path: '/medizin/labor', label: 'Labor', icon: 'FlaskConical', permission: 'laboratory.read' },
      { path: '/medizin/op', label: 'OP', icon: 'Scissors', permission: 'operations.read' },
      { path: '/medizin/radiologie', label: 'Radiologie', icon: 'ScanLine', permission: 'radiology.read' },
      { path: '/medizin/arztbriefe', label: 'Arztbriefe', icon: 'Mail', permission: 'letters.read' },
    ],
  },
  {
    label: 'Organisation',
    path: '/organisation',
    icon: 'Calendar',
    permission: 'calendar.read',
    children: [
      { path: '/organisation/kalender', label: 'Kalender', icon: 'Calendar', permission: 'calendar.read' },
      { path: '/organisation/termine', label: 'Termine', icon: 'Clock', permission: 'calendar.create' },
      { path: '/organisation/besprechungen', label: 'Besprechungen', icon: 'Users', permission: 'meetings.read' },
      { path: '/organisation/raeume', label: 'Raumbelegung', icon: 'MapPin', permission: 'rooms.read' },
      { path: '/organisation/veranstaltungen', label: 'Veranstaltungen', icon: 'Calendar', permission: 'events.read' },
    ],
  },
  {
    label: 'Wissen',
    path: '/wissen',
    icon: 'BookOpen',
    permission: 'documents.read',
    children: [
      { path: '/wissen/dokumente', label: 'Dokumente', icon: 'FileText', permission: 'documents.read' },
      { path: '/wissen/sops', label: 'SOPs', icon: 'FileText', permission: 'sops.read' },
      { path: '/wissen/dienstanweisungen', label: 'Dienstanweisungen', icon: 'ClipboardList', permission: 'documents.read' },
      { path: '/wissen/leitlinien', label: 'Leitlinien', icon: 'BookOpen', permission: 'guidelines.read' },
      { path: '/wissen/faq', label: 'FAQ', icon: 'HelpCircle', permission: 'faq.read' },
      { path: '/wissen/schulungen', label: 'Schulungen', icon: 'GraduationCap', permission: 'trainings.read' },
      { path: '/wissen/elearning', label: 'E-Learning', icon: 'Monitor', permission: 'elearning.read' },
    ],
  },
  {
    label: 'Kommunikation',
    path: '/kommunikation',
    icon: 'MessageSquare',
    permission: 'news.read',
    children: [
      { path: '/kommunikation/news', label: 'News', icon: 'Newspaper', permission: 'news.read' },
      { path: '/kommunikation/bekanntmachungen', label: 'Bekanntmachungen', icon: 'Megaphone', permission: 'announcements.read' },
      { path: '/kommunikation/umfragen', label: 'Umfragen', icon: 'ClipboardList', permission: 'surveys.read' },
      { path: '/kommunikation/chat', label: 'Interner Chat', icon: 'MessageCircle', permission: 'chat.read' },
      { path: '/kommunikation/benachrichtigungen', label: 'Benachrichtigungen', icon: 'Bell', permission: 'notifications.read' },
    ],
  },
  {
    label: 'Sicherheit & Notfall',
    path: '/notfall',
    icon: 'AlertTriangle',
    permission: 'emergency.read',
    children: [
      { path: '/notfall/notruf', label: 'Notruf', icon: 'PhoneCall', permission: 'emergency.read' },
      { path: '/notfall/alarmplaene', label: 'Alarmpläne', icon: 'AlertTriangle', permission: 'alarms.read' },
      { path: '/notfall/evakuierung', label: 'Evakuierung', icon: 'DoorOpen', permission: 'evacuation.read' },
      { path: '/notfall/notfallplaene', label: 'Notfallpläne', icon: 'FileText', permission: 'emergency.read' },
      { path: '/notfall/rufbereitschaften', label: 'Rufbereitschaften', icon: 'Phone', permission: 'oncall.read' },
      { path: '/notfall/kriseninformationen', label: 'Kriseninformationen', icon: 'AlertCircle', permission: 'crisis.read' },
    ],
  },
  {
    label: 'Betrieb',
    path: '/betrieb',
    icon: 'Building2',
    permission: 'material.read',
    children: [
      { path: '/betrieb/material', label: 'Material', icon: 'Package', permission: 'material.read' },
      { path: '/betrieb/bestellungen', label: 'Bestellungen', icon: 'ShoppingCart', permission: 'orders.read' },
      { path: '/betrieb/lager', label: 'Lager', icon: 'Archive', permission: 'storage.read' },
      { path: '/betrieb/raeume', label: 'Räume', icon: 'Building', permission: 'rooms.read' },
      { path: '/betrieb/technik', label: 'Technik', icon: 'Wrench', permission: 'technology.read' },
      { path: '/betrieb/it', label: 'IT-Helpdesk', icon: 'Monitor', permission: 'it.read' },
      { path: '/betrieb/stoerungen', label: 'Störungsmeldungen', icon: 'AlertCircle', permission: 'incidents.read' },
    ],
  },
  {
    label: 'Verwaltung',
    path: '/verwaltung',
    icon: 'Settings',
    permission: 'administration.read',
    children: [
      { path: '/verwaltung/personal', label: 'Personalverwaltung', icon: 'Users', permission: 'personnel.read' },
      { path: '/verwaltung/berechtigungen', label: 'Berechtigungen', icon: 'Shield', permission: 'permissions.read' },
      { path: '/verwaltung/abteilungen', label: 'Abteilungen', icon: 'Building2', permission: 'departments.read' },
      { path: '/verwaltung/kostenstellen', label: 'Kostenstellen', icon: 'DollarSign', permission: 'costcenters.read' },
      { path: '/verwaltung/dokumente', label: 'Dokumentenverwaltung', icon: 'FolderOpen', permission: 'documents.read' },
      { path: '/verwaltung/auswertungen', label: 'Auswertungen', icon: 'BarChart', permission: 'administration.read' },
    ],
  },
  {
    label: 'System',
    path: '/system',
    icon: 'Cpu',
    permission: 'system.status',
    children: [
      { path: '/system/suche', label: 'Globale Suche', icon: 'Search', permission: 'system.status' },
      { path: '/system/audit', label: 'Audit-Log', icon: 'History', permission: 'audit.read' },
      { path: '/system/rollen', label: 'Rollen & Rechte', icon: 'Shield', permission: 'permissions.read' },
      { path: '/system/einstellungen', label: 'Einstellungen', icon: 'Settings', permission: 'settings.read' },
      { path: '/system/datenschutz', label: 'Datenschutz', icon: 'Lock', permission: 'dataprotection.read' },
      { path: '/system/status', label: 'Systemstatus', icon: 'Activity', permission: 'system.status' },
    ],
  },
];

export function filterNavigationByPermissions(
  items: PermissionNavigationItem[],
  permissions: string[]
): PermissionNavigationItem[] {
  return items
    .map(item => {
      if (item.children) {
        const filteredChildren = filterNavigationByPermissions(item.children, permissions);
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
        if (item.permission && permissions.includes(item.permission)) {
          return item;
        }
        return null;
      }

      return item.permission && !permissions.includes(item.permission) ? null : item;
    })
    .filter((item): item is PermissionNavigationItem => item !== null);
}
